import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

const getShopDetailProductId = (pathname) => {
  const parts = String(pathname || '').split('/').filter(Boolean);
  if (parts[0] !== 'dashboard' || parts[1] !== 'shop' || parts[2] !== 'produkt') return null;
  return parts[3] || null;
};

const shouldKeepScrollPosition = (previousPathname, nextPathname) => {
  if (!previousPathname || !nextPathname) return false;
  const previousProductId = getShopDetailProductId(previousPathname);
  const nextProductId = getShopDetailProductId(nextPathname);
  return Boolean(previousProductId && nextProductId && previousProductId === nextProductId);
};

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const previousPathnameRef = useRef(null);

  useEffect(() => {
    const previousPathname = previousPathnameRef.current;
    if (!shouldKeepScrollPosition(previousPathname, pathname)) {
      window.scrollTo(0, 0);
    }
    previousPathnameRef.current = pathname;
  }, [pathname]);

  return null;
}
